import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/lib/content";

const fade = {
  initial: { opacity: 0, y: 18 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] },
  viewport: { once: true, margin: "-80px" },
};

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="border-t border-hairline">
      <div className="max-w-5xl mx-auto px-6 lg:px-8 py-28 lg:py-40">
        <motion.div {...fade} className="max-w-2xl">
          <span className="overline" data-testid="faq-overline">FAQ</span>
          <h2 className="font-serif text-4xl md:text-6xl font-medium leading-[0.95] tracking-tight mt-6">
            Quiet answers
            <br />
            <span className="italic font-light text-platinum">to honest questions.</span>
          </h2>
        </motion.div>

        <motion.div {...fade} className="mt-20">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-hairline"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-8 text-left font-serif text-xl md:text-2xl text-bone hover:text-platinum hover:no-underline transition-colors"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-10 font-sans text-base md:text-lg text-sand leading-relaxed max-w-3xl">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
